import { call, put } from 'redux-saga/effects';
import { providerSignupFailure, providerSignupSuccess } from '../actions';
import { providerSignup } from '../api';
import { ProviderSignupRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { navigateToExternalPage } from 'utils/validation/common';
import { renderErrorMessage } from 'utils/render-error-message';
import { logoutRequest } from 'store/auth/actions';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* providerSignupSaga(action: ProviderSignupRequestAction) {
  try {
    let err: ApiError | null;

    const { provider, providerFormattedName } = action.payload;
    const response = yield call(providerSignup, provider);
    const providerUrl: string = response.data.url;

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('login.page-title-contacting', {
        provider: providerFormattedName,
      }),
      description: i18n.t('login.please-be-patient-it-might-take-few-seconds'),
      type: MessageStates.INFO,
    };

    yield put(turnMessageOn(message));
    yield call(navigateToExternalPage, providerUrl);
    yield put(providerSignupSuccess());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(providerSignupFailure());
  }
}
